import React, { useMemo } from 'react';

import ConnectedEntityPickerModal, {
  ConnectedEntityPickerModalProps,
} from './ConnectedEntityPickerModal';
import PluginProvidersProvider from '../providers/PluginProvidersProvider';
import { EntityWithId } from '../types/types';

type EntityPickerModalBaseProps<T> = Omit<
  ConnectedEntityPickerModalProps<T>,
  'onSave' | 'multiple'
>;

interface MultipleTrueProps<T> extends EntityPickerModalBaseProps<T> {
  multiple: true;
  onSave: (selectedEntities: T[]) => Promise<void> | void;
}

interface MultipleFalseProps<T> extends EntityPickerModalBaseProps<T> {
  multiple?: false | undefined;
  onSave: (selectedEntity: T) => Promise<void> | void;
}

type EntityPickerModalProps<T = EntityWithId> =
  | MultipleTrueProps<T>
  | MultipleFalseProps<T>;

const EntityPickerModal = <T extends EntityWithId>(
  props: EntityPickerModalProps<T>,
) => {
  const pluginAsArray = useMemo(
    () => (props.plugin ? [props.plugin] : []),
    [props.plugin],
  );
  return (
    <PluginProvidersProvider plugins={pluginAsArray}>
      <ConnectedEntityPickerModal {...props} />
    </PluginProvidersProvider>
  );
};

export default EntityPickerModal;
